import { FC, ReactNode } from "react";

interface SocialButtonProps {
  href: string;
  children: ReactNode;
  label: string;
}

const SocialButton: FC<SocialButtonProps> = ({ href, children, label }) => (
  <a
    href={href}
    target={href.startsWith('http') ? "_blank" : undefined}
    rel={href.startsWith('http') ? "noopener noreferrer" : undefined}
    aria-label={label}
    className="p-3 bg-card rounded-lg border border-border hover:border-primary transition-colors hover:glow-effect"
  >
    {children}
  </a>
);

export default SocialButton;
